export default __webpack_public_path__ + "img/86e712f9b092f8764cc55a62f7353d0d.png";